module.exports = __webpack_public_path__ + "static/image2-5b14b5917f5d776e52f6ce055d698f51.png";